import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ToastService} from "../../services/toast.service";
import {LangService} from "../../services/lang.service";

interface Article {
    slug: string;
    title: string;
    categoryTitle: string;
    categorySlug: string;
}

@Component({
    selector: 'app-block-recommended-articles',
    templateUrl: './block-recommended-articles.component.html',
    styleUrls: ['./block-recommended-articles.component.scss'],
    standalone: false
})
export class BlockRecommendedArticlesComponent  implements OnInit {
    @Input() articles: Article[] = [];
    @Input() seeMoreRoute: string = '/articles'
    @ViewChild('swiperRecommendedArticle', {static: false}) swiperRecommendedArticle: ElementRef | undefined;
    constructor(
        public toastService: ToastService,
        public lang: LangService
    ) {
    }
    ngOnInit() {
    }

    /**
     * Swipe Slide
     * 0 - Back / Prev
     * 1 - Next
     * @param type
     */
    swipeSlide(type : number = 0) {
        // @ts-ignore
        const swiperInstance = this.swiperRecommendedArticle.nativeElement.swiper;

        (type === 1)
            ? swiperInstance.slideNext()
            : swiperInstance.slidePrev();
    }
}
